export const ProcessStepSizes = {
  icon: 0.1875,
  small: 0.75,
  default: 1,
  large: 1.125,
} as const;
export type ProcessStepSizes = (typeof ProcessStepSizes)[keyof typeof ProcessStepSizes];

export type ProcessStep = {
  id?: string;
  statuses: string[];
  label: string;
  disabled?: boolean;
  state: ProcessStepState;
};

export const ProcessStepState = {
  Open: 0,
  Active: 1,
  Done: 2,
} as const;
export type ProcessStepState = (typeof ProcessStepState)[keyof typeof ProcessStepState];
